import { useEffect, useState } from 'react';
import { Platform, Text, View } from 'react-native';
import { Link } from 'expo-router';
import Animated, { FadeInDown, FadeOutDown } from 'react-native-reanimated';

import { Button } from '@/components/ui/button';
import { getCookieConsent, setCookieConsent, type CookieConsent } from '@/lib/cookie-consent';
import { initMetaPixel } from '@/lib/meta-pixel';

/** Banner LGPD (web only). Meta Pixel só carrega depois do aceite. */
export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (Platform.OS !== 'web') return;
    const consent = getCookieConsent();
    if (consent === 'accepted') initMetaPixel();
    else if (consent === null) setVisible(true);
  }, []);

  if (!visible) return null;

  const choose = (value: CookieConsent) => {
    setCookieConsent(value);
    if (value === 'accepted') initMetaPixel();
    setVisible(false);
  };

  return (
    <Animated.View
      entering={FadeInDown.duration(250)}
      exiting={FadeOutDown.duration(200)}
      style={{ position: 'fixed' as never, left: 16, right: 16, bottom: 16, zIndex: 50, alignItems: 'flex-end' }}
      pointerEvents="box-none"
    >
      <View className="w-full max-w-sm rounded-2xl border border-border bg-card p-4 shadow-lg">
        <Text className="text-sm text-foreground">
          Usamos cookies essenciais para o app funcionar e, com sua permissão, cookies de marketing
          para medir anúncios.{' '}
          <Link href="/privacidade" className="text-primary underline">
            Política de privacidade
          </Link>
        </Text>
        <View className="mt-3 flex-row justify-end gap-2">
          <Button variant="ghost" size="sm" onPress={() => choose('rejected')}>
            Só essenciais
          </Button>
          <Button variant="default" size="sm" onPress={() => choose('accepted')}>
            Aceitar
          </Button>
        </View>
      </View>
    </Animated.View>
  );
}
